module.exports = __webpack_public_path__ + "img/ico-bots.0fdefa6f.svg";